import React from 'react';
import Typography from '@mui/material/Typography';

export const removeParentheticals = (str: string): string => {
  return str.replace(/\(.*?\)/g, '').trim();
};

export const getTitle = (preferences: string[], sectionTitle: string) => {
  switch (preferences.length) {
    case 1:
      return preferences[0];
    case 2:
      return `${preferences[0]} & ${preferences[1]}`;
    case 3:
      return `${preferences[0]}, ${preferences[1]} & ${preferences[2]}`;
    default:
      return sectionTitle;
  }
};

export const getList = (strings: string[], max?: number): JSX.Element[] => {
  if (strings.length === 0) return [];

  if (strings.length === 1) {
    return [
      <Typography variant="bodyLargeHeavy" component="span" key={0}>
        {strings[0]}
      </Typography>,
    ];
  }

  if (max !== undefined && strings.length > max) {
    const sliced = strings.slice(0, max);
    if (sliced.length > 1) {
      return [
        ...sliced.map((str, index) => (
          <React.Fragment key={index}>
            <Typography variant="bodyLargeHeavy" component="span">
              {str}
            </Typography>
            ,{' '}
          </React.Fragment>
        )),
        <span key="more">and more</span>,
      ];
    } else {
      return [
        <React.Fragment key={1}>
          <Typography variant="bodyLargeHeavy" component="span">
            {sliced[0]}
          </Typography>{' '}
        </React.Fragment>,
        <span key="more">and more</span>,
      ];
    }
  }

  if (strings.length === 2) {
    return [
      <Typography variant="bodyLargeHeavy" component="span" key={0}>
        {strings[0]}
      </Typography>,
      <span key="and"> and </span>,
      <Typography variant="bodyLargeHeavy" component="span" key={1}>
        {strings[1]}
      </Typography>,
    ];
  }

  const last = strings.pop();
  return [
    ...strings.map((str, index) => (
      <React.Fragment key={index}>
        <Typography variant="bodyLargeHeavy" component="span">
          {str}
        </Typography>
        ,{' '}
      </React.Fragment>
    )),
    <span key="and">and </span>,
    <Typography variant="bodyLargeHeavy" component="span" key={strings.length}>
      {last}
    </Typography>,
  ];
};
